var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerceivedStress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "192px",
    viewBox: "0 0 256 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-perceived-stress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.083333,1.000000),rotate(90.000000),scale(1.000000,12.250247),translate(-0.489155,-0.509384)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "31.2158978%",
    x2: "24.2768159%",
    y2: "67.9439484%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "22.8553185%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72,174 L94,174 L94,184.44 C94,187.510703 91.5107032,190 88.44,190 L77.56,190 C74.4892968,190 72,187.510703 72,184.44 L72,174 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.5280762%",
    x2: "50%",
    y2: "80.4794312%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61,134 L105,134 L105,164.1 C105,171.776758 98.776758,178 91.1,178 L74.9,178 C67.223242,178 61,171.776758 61,164.1 L61,134 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 83,
    cy: 83,
    r: 78
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-1.6%",
    width: "103.2%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-11",
    cx: 83,
    cy: 83,
    r: 68
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.6%",
    y: "-2.6%",
    width: "105.1%",
    height: "105.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-14",
    cx: 83,
    cy: 83,
    r: 68
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.1%",
    y: "-3.1%",
    width: "106.3%",
    height: "106.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-16",
    cx: 83,
    cy: 83,
    r: 72
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.1%",
    y: "-3.1%",
    width: "106.2%",
    height: "106.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "16.0651508%",
    x2: "0%",
    y2: "83.9348492%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.5772268,-0.220545788 L12.5819472,69.5463371 C12.455513,71.7541717 14.1428215,73.6464705 16.3506561,73.7729046 C16.4261027,73.7772252 16.5016565,73.779409 16.5772268,73.7794535 C18.7860787,73.7807546 20.5777618,71.9911811 20.5790629,69.7823291 C20.5791083,69.705282 20.5769273,69.6282496 20.5725226,69.5513284 L16.5772268,-0.220545788 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-4.1%",
    width: "249.8%",
    height: "116.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH-??-(Mental-Health-Quiz)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mental-Health-Assess-LG-03.0.0",
    transform: "translate(-736.000000, -547.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R-&-PS",
    transform: "translate(161.000000, 483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "perceived-stress",
    transform: "translate(511.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-perceived-stress-wide",
    transform: "translate(64.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "double-shadow-01",
    transform: "translate(32.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    fill: "url(#radialGradient-1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 96,
    cy: 6,
    rx: 96,
    ry: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small",
    transform: "translate(42.000000, 0.000000)",
    fill: "url(#radialGradient-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 54,
    cy: 4.5,
    rx: 54,
    ry: 4.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M222.101731,82.8181823 C222.059257,82.4561887 222.03741,82.0878128 222.03741,81.7142857 C222.03741,76.5859273 226.155585,72.4285714 231.235611,72.4285714 C233.993709,72.4285714 236.468279,73.6540469 238.154181,75.5950509 C239.751224,72.8459295 242.709196,71 246.094244,71 C251.174271,71 255.292446,75.1573559 255.292446,80.2857143 C255.292446,82.2750016 254.672801,84.118186 253.617731,85.629294 C255.074866,87.0050488 256,89.0605489 256,91.3571429 C256,95.4992785 252.990564,98.8571429 249.278237,98.8571429 C247.791806,98.8571429 246.418064,98.3187981 245.30508,97.4073184 C244.173626,99.5452612 241.941339,101 239.372482,101 C236.534721,101 234.107682,99.224762 233.121632,96.7143569 C231.896651,97.6129029 230.389217,98.1428571 228.759172,98.1428571 C224.656074,98.1428571 221.329856,94.7849928 221.329856,90.6428571 C221.329856,90.0927461 221.388524,89.5564681 221.499888,89.0400518 L211.545479,86.6952578 C211.161498,86.60481 210.923543,86.22021 211.013991,85.8362297 C211.07608,85.5726413 211.28189,85.3668313 211.545479,85.3047422 L222.101728,82.818183 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.101731,82.8181823 C11.0592566,82.4561887 11.0374095,82.0878128 11.0374095,81.7142857 C11.0374095,76.5859273 15.1555847,72.4285714 20.2356111,72.4285714 C22.9937091,72.4285714 25.4682794,73.6540469 27.1541811,75.5950509 C28.7512237,72.8459295 31.7091957,71 35.0942445,71 C40.1742709,71 44.292446,75.1573559 44.292446,80.2857143 C44.292446,82.2750016 43.6728008,84.118186 42.6177314,85.629294 C44.0748655,87.0050488 45,89.0605489 45,91.3571429 C45,95.4992785 41.9905643,98.8571429 38.2782373,98.8571429 C36.7918058,98.8571429 35.4180644,98.3187981 34.3050798,97.4073184 C33.1736265,99.5452612 30.9413392,101 28.3724818,101 C25.534721,101 23.1076815,99.224762 22.1216322,96.7143569 C20.896651,97.6129029 19.3892171,98.1428571 17.7591722,98.1428571 C13.6560739,98.1428571 10.3298556,94.7849928 10.3298556,90.6428571 C10.3298556,90.0927461 10.3885238,89.5564681 10.4998884,89.0400518 L0.545478577,86.6952578 C0.161498306,86.60481 -0.0764567627,86.22021 0.0139910542,85.8362297 C0.0760801858,85.5726413 0.281890108,85.3668313 0.545478577,85.3047422 L11.1017276,82.818183 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)",
    transform: "translate(22.500000, 86.000000) scale(-1, 1) translate(-22.500000, -86.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "pressure",
    transform: "translate(45.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#linearGradient-8)",
    strokeWidth: 2,
    strokeLinejoin: "square",
    cx: 83,
    cy: 83,
    r: 77
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-13)",
    strokeWidth: 1.51355556,
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.5,
    transform: "translate(83.000000, 83.000000) rotate(-90.000000) translate(-83.000000, -83.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-13)",
    strokeWidth: 2,
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.0408883,141 C115.073396,141.022567 141.022567,115.073396 141,83.0408883 C140.977403,51.0083809 114.991619,25.0225967 82.9591117,25 C50.9266044,24.9774328 24.9774328,50.9266044 25,82.9591117",
    id: "Oval",
    stroke: "#575756",
    strokeWidth: 1.4595,
    strokeLinecap: "round",
    strokeDasharray: "21.35853610038757,28.47804813385009",
    transform: "translate(83.000000, 83.000000) rotate(-45.000000) translate(-83.000000, -83.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1403188,116.030729 C36.5689155,107.131899 32,95.599513 32,83 C32,54.8334778 54.8334778,32 83,32 C111.166522,32 134,54.8334778 134,83 C134,95.599513 129.431084,107.131899 121.859681,116.030729 L83,83 L44.1403188,116.030729 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.062446,46.9375542 C128.291631,56.1667389 134,68.9167389 134,83 C134,97.0832611 128.291631,109.833261 119.062446,119.062446 L83,83 L119.062446,46.9375542 Z",
    id: "Combined-Shape",
    fill: "#FF520B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    x: 65,
    y: 130,
    width: 36,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "needle",
    transform: "translate(90.169199, 66.173901) rotate(43.000000) translate(-90.169199, -66.173901) translate(73.669199, 29.673901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4",
    transform: "translate(16.577172, 36.779454) rotate(-20.000000) translate(-16.577172, -36.779454) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-20)",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-19"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#575756",
    cx: 83.0112875,
    cy: 83,
    rx: 8.01128748,
    ry: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D9D9D9",
    cx: 83,
    cy: 82.9943642,
    rx: 4,
    ry: 3.99436421
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 83,
    cy: 82.9985911,
    rx: 1,
    ry: 1
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerceivedStress);
export default __webpack_public_path__ + "static/media/perceived-stress.4d41c2e1cda835d4de25adec1538db1d.svg";
export { ForwardRef as ReactComponent };